export const TOKEN_KEY = "hapon-admin-auth";
export const USER_DATA = "hapon-admin-user-data";
export const ADMIN_BFF_AZKV = "___ADMIN_BFF_URL___";
export const BFF_KEY_AZKV = "___BFF_KEY___";
export const ADMIN_BFF_DEV = "https://api-dev.hapvidalabs.net/hapon/admin";
export const BFF_KEY_DEV = "4193c63d18a34b988c05de7e6685e6bb";
export const ADMIN_BFF_HML = "https://api-hml.hapvidalabs.net/hapon/admin";
export const BFF_KEY_HML = "a5b7b185472d4949b2483ebfb285c8e8";
export const ADMIN_BFF_PRD = "https://api.hapvida.com.br/hapon/admin";
export const BFF_KEY_PRD = "dfb048764d284ae0aa88b927e65db8b7";

export type AdminEnvironment = "DEV" | "HML" | "PRD";
export type AdminEnvironmentOverride = AdminEnvironment | undefined;

const normalizeAdminEnvironmentOverride = (
  environment?: string,
): AdminEnvironmentOverride => {
  const normalizedEnvironment = environment?.trim().toUpperCase();

  if (
    normalizedEnvironment === "DEV" ||
    normalizedEnvironment === "HML" ||
    normalizedEnvironment === "PRD"
  ) {
    return normalizedEnvironment;
  }

  return undefined;
};

export const getAdminBffUrlByEnvironment = (
  environment?: string,
): string => {
  switch (normalizeAdminEnvironmentOverride(environment)) {
    case "DEV":
      return ADMIN_BFF_DEV;
    case "HML":
      return ADMIN_BFF_HML;
    case "PRD":
      return ADMIN_BFF_PRD;
    default:
      return ADMIN_BFF_AZKV;
  }
};

export const getBffKeyByEnvironment = (environment?: string): string => {
  switch (normalizeAdminEnvironmentOverride(environment)) {
    case "DEV":
      return BFF_KEY_DEV;
    case "HML":
      return BFF_KEY_HML;
    case "PRD":
      return BFF_KEY_PRD;
    default:
      return BFF_KEY_AZKV;
  }
};

export const ADMIN_BFF_URL = getAdminBffUrlByEnvironment(
  process.env.REACT_APP_ADMIN_ENVIRONMENT,
);
export const BFF_KEY = getBffKeyByEnvironment(
  process.env.REACT_APP_ADMIN_ENVIRONMENT,
);

export const getAdminEnvironment = (
  adminBffUrl: string = ADMIN_BFF_URL,
): AdminEnvironment => {
  const normalizedUrl = adminBffUrl.toLowerCase();

  if (
    normalizedUrl === ADMIN_BFF_PRD.toLowerCase() ||
    normalizedUrl.includes("api.hapvida.com.br")
  ) {
    return "PRD";
  }

  if (
    normalizedUrl === ADMIN_BFF_HML.toLowerCase() ||
    normalizedUrl.includes("api-hml")
  ) {
    return "HML";
  }

  return "DEV";
};

export const CURRENT_ADMIN_ENVIRONMENT = getAdminEnvironment();
